import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faPenToSquare,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import * as XLSX from "xlsx";

import Layouts from "../../layouts/layouts";
import DataTable_Component from "../../components/assets/Data Table";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Add_data_modal from "../../components/assets/update_data_modal";
import AssetDetailModal from "../../components/assets/Asset Details";

export default function Asset() {
  const title = "Asset Details";

  const [apistate, setApiState] = useState([]);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [showAssetDetailModal, setShowAssetDetailModal] = useState(false);

  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);

  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });

  const [update_modal_data, setUpdate_modal_data] = useState("");

  // ============================================================
  // PAGINATION
  // ============================================================

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalAssets, setTotalAssets] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  // ============================================================
  // SEARCH
  // ============================================================

  const [search, setSearch] = useState("");

  // ============================================================
  // FILTERS
  // ============================================================

  const emptyFilters = {
    assignFromDate: "",
    assignToDate: "",
    id_user: "",
    vehicle: "",
    approved: "",
    approvedBy: "",
    company: "",
    id_hub: "",
  };

  const [filters, setFilters] = useState(emptyFilters);

  // ============================================================
  // SUMMARY
  // ============================================================

  const [summary, setSummary] = useState({
    count: 0,
    quantity: 0,
    amount: 0,
  });

  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");

  // ============================================================
  // HELPERS
  // ============================================================

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);

    if (Number.isNaN(date.getTime())) {
      return "N/A";
    }

    return date.toLocaleDateString("en-GB");
  };

  const getAmount = (row) => {
    const unitCost = Number(row?.assetType?.unitCost || 0);
    const quantity = Number(row?.quantity || 0);

    return unitCost * quantity;
  };

  // ============================================================
  // TABLE COLUMNS
  // ============================================================

  const columns = [
    {
      name: <b>Asset Name</b>,
      selector: (row) => row?.assetType?.assetname || "N/A",
      sortable: true,
      minWidth: "140px",
    },

    {
      name: <b>User</b>,
      selector: (row) => row?.user?.name || "N/A",
      sortable: true,
      minWidth: "160px",
    },

    {
      name: <b>Assign From</b>,
      selector: (row) => formatDate(row?.assignFromDate),
      sortable: true,
      minWidth: "130px",
    },

    {
      name: <b>Assign To</b>,
      selector: (row) => formatDate(row?.assignToDate),
      sortable: true,
      minWidth: "130px",
    },

    {
      name: <b>Vehicle</b>,
      selector: (row) => row?.vehicleData?.numberplate || "N/A",
      sortable: true,
      minWidth: "130px",
    },

    {
      name: <b>Approved</b>,
      cell: (row) => (
        <span className={`badge ${row?.approved ? "bg-success" : "bg-danger"}`}>
          {row?.approved ? "Yes" : "No"}
        </span>
      ),
      sortable: true,
      minWidth: "100px",
    },

    {
      name: <b>Approved By</b>,
      selector: (row) => row?.approvedByData?.name || "N/A",
      sortable: true,
      minWidth: "140px",
    },

    {
      name: <b>Company</b>,
      selector: (row) => row?.company || "N/A",
      sortable: true,
      minWidth: "120px",
    },

    {
      name: <b>Quantity</b>,
      selector: (row) => row?.quantity ?? 0,
      sortable: true,
      center: true,
      minWidth: "100px",
    },

    {
      name: <b>Hub</b>,
      selector: (row) => row?.hubData?.name || "N/A",
      sortable: true,
      minWidth: "120px",
    },

    {
      name: <b>Amount</b>,
      selector: (row) => getAmount(row),
      format: (row) => `₹${getAmount(row).toLocaleString("en-IN")}`,
      sortable: true,
      minWidth: "120px",
    },

    {
      name: <b>Action</b>,
      cell: (row) => (
        <div className="d-flex align-items-center">
          <button
            onClick={() => setUpdateStoreBtn(row)}
            className="btn btn-info btn-sm"
            title="Edit"
          >
            <FontAwesomeIcon icon={faPenToSquare} />
          </button>

          <button
            onClick={() => delete_row(row)}
            className="btn btn-danger btn-sm ms-1"
            title="Delete"
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>

          <button
            onClick={() => viewAsset(row)}
            className="btn btn-primary btn-sm ms-1"
            title="View"
          >
            <FontAwesomeIcon icon={faEye} />
          </button>
        </div>
      ),
      minWidth: "140px",
    },
  ];

  // ============================================================
  // FETCH ASSETS
  // ============================================================

  const fetchAsset = async (
    page = currentPage,
    limit = rowsPerPage,
    searchValue = search,
    filterValues = filters,
  ) => {
    try {
      if (!token) {
        console.error("No token found");
        return;
      }

      setLoading(true);

      let query = `?page=${page}&limit=${limit}`;

      if (searchValue?.trim()) {
        query += `&search=${encodeURIComponent(searchValue.trim())}`;
      }

      if (filterValues.assignFromDate) {
        query += `&assignFromDate=${encodeURIComponent(
          filterValues.assignFromDate,
        )}`;
      }

      if (filterValues.assignToDate) {
        query += `&assignToDate=${encodeURIComponent(
          filterValues.assignToDate,
        )}`;
      }

      if (filterValues.id_user) {
        query += `&id_user=${encodeURIComponent(filterValues.id_user)}`;
      }

      if (filterValues.vehicle) {
        query += `&vehicle=${encodeURIComponent(filterValues.vehicle)}`;
      }

      if (filterValues.approved !== "") {
        query += `&approved=${encodeURIComponent(filterValues.approved)}`;
      }

      if (filterValues.approvedBy) {
        query += `&approvedBy=${encodeURIComponent(filterValues.approvedBy)}`;
      }

      if (filterValues.company) {
        query += `&company=${encodeURIComponent(filterValues.company)}`;
      }

      if (filterValues.id_hub) {
        query += `&id_hub=${encodeURIComponent(filterValues.id_hub)}`;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/assets${query}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      console.log("Asset API Response:", response.data);

      if (Array.isArray(response.data.assets)) {
        setApiState(response.data.assets);
      } else {
        setApiState([]);
      }

      setSummary(
        response.data.summary || {
          count: 0,
          quantity: 0,
          amount: 0,
        },
      );

      setTotalAssets(response.data.pagination?.totalAssets || 0);

      setTotalPages(response.data.pagination?.totalPages || 0);
    } catch (error) {
      console.error(
        "Error fetching assets:",
        error.response?.data || error.message,
      );

      setApiState([]);

      setSummary({
        count: 0,
        quantity: 0,
        amount: 0,
      });
    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  // INITIAL FETCH
  // ============================================================

  useEffect(() => {
    fetchAsset(1, rowsPerPage, search, filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ============================================================
  // SEARCH
  // ============================================================

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setCurrentPage(1);
      fetchAsset(1, rowsPerPage, search, filters);
    }, 500);

    return () => clearTimeout(delayDebounce);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  // ============================================================
  // PAGINATION
  // ============================================================

  const handlePageChange = (page) => {
    setCurrentPage(page);

    fetchAsset(page, rowsPerPage, search, filters);
  };

  const handleRowsPerPageChange = (newLimit, page) => {
    setRowsPerPage(newLimit);
    setCurrentPage(page);

    fetchAsset(page, newLimit, search, filters);
  };

  // ============================================================
  // APPLY FILTERS
  // ============================================================

  const handleApplyFilters = (newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1);

    fetchAsset(1, rowsPerPage, search, newFilters);
  };

  // ============================================================
  // CLEAR FILTERS
  // ============================================================

  const handleClearFilters = () => {
    const emptyFilterValues = {
      assignFromDate: "",
      assignToDate: "",
      id_user: "",
      vehicle: "",
      approved: "",
      approvedBy: "",
      company: "",
      id_hub: "",
    };

    setFilters(emptyFilterValues);
    setCurrentPage(1);

    fetchAsset(1, rowsPerPage, search, emptyFilterValues);
  };

  // ============================================================
  // UPDATE MODAL
  // ============================================================

  const setUpdateStoreBtn = (row) => {
    setUpdate_modal_data(row);

    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
  };

  const updateAsset = (updatedAsset) => {
    setApiState((prev) =>
      prev.map((asset) =>
        asset._id === updatedAsset._id ? updatedAsset : asset,
      ),
    );
  };

  // ============================================================
  // DELETE
  // ============================================================

  const delete_row = (row) => {
    Swal.fire({
      icon: "warning",
      title: "Delete Asset?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      try {
        if (!token) {
          console.error("No token found");
          return;
        }

        await axios.delete(
          `${process.env.REACT_APP_BASE_URL}/api/v1/assets/${row._id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );

        Swal.fire(
          "Deleted!",
          "Asset has been deleted successfully.",
          "success",
        );

        fetchAsset(currentPage, rowsPerPage, search, filters);
      } catch (error) {
        console.error(
          "Error deleting asset:",
          error.response?.data || error.message,
        );

        Swal.fire(
          "Error!",
          error.response?.data?.message || "Asset could not be deleted.",
          "error",
        );
      }
    });
  };

  // ============================================================
  // VIEW ASSET
  // ============================================================

  const viewAsset = (asset) => {
    setSelectedAsset(asset);
    setShowAssetDetailModal(true);
  };

  // ============================================================
  // UPDATE API
  // ============================================================

  const handleUpdateAsset = async (updatedAssetData) => {
    try {
      if (!token) {
        console.error("No token found");
        return;
      }

      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/v1/assets/${updatedAssetData._id}`,
        updatedAssetData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      Swal.fire("Updated!", "Asset details have been updated.", "success");

      if (response.data.asset) {
        updateAsset(response.data.asset);
      }

      fetchAsset(currentPage, rowsPerPage, search, filters);
    } catch (error) {
      console.error(
        "Error updating asset:",
        error.response?.data || error.message,
      );

      Swal.fire(
        "Error!",
        error.response?.data?.message || "Asset details could not be updated.",
        "error",
      );
    }
  };

  // ============================================================
  // EXPORT EXCEL
  // ============================================================

  const exportToExcel = async () => {
    try {
      if (!token) {
        console.error("No token found");
        return;
      }

      Swal.fire({
        title: "Preparing Excel...",
        text: "Please wait",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      let query = `?page=1&limit=100000`;

      if (search?.trim()) {
        query += `&search=${encodeURIComponent(search.trim())}`;
      }

      if (filters.assignFromDate) {
        query += `&assignFromDate=${encodeURIComponent(
          filters.assignFromDate,
        )}`;
      }

      if (filters.assignToDate) {
        query += `&assignToDate=${encodeURIComponent(filters.assignToDate)}`;
      }

      if (filters.id_user) {
        query += `&id_user=${encodeURIComponent(filters.id_user)}`;
      }

      if (filters.vehicle) {
        query += `&vehicle=${encodeURIComponent(filters.vehicle)}`;
      }

      if (filters.approved !== "") {
        query += `&approved=${encodeURIComponent(filters.approved)}`;
      }

      if (filters.approvedBy) {
        query += `&approvedBy=${encodeURIComponent(filters.approvedBy)}`;
      }

      if (filters.company) {
        query += `&company=${encodeURIComponent(filters.company)}`;
      }

      if (filters.id_hub) {
        query += `&id_hub=${encodeURIComponent(filters.id_hub)}`;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/assets${query}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const assets = response.data.assets || [];

      const transformedData = assets.map((asset, index) => ({
        "S.No": index + 1,

        "Asset Name": asset?.assetType?.assetname || "N/A",

        "User Name": asset?.user?.name || "N/A",

        "User Email": asset?.user?.email || "N/A",

        "Assign From": formatDate(asset?.assignFromDate),

        "Assign To": formatDate(asset?.assignToDate),

        Vehicle: asset?.vehicleData?.numberplate || "N/A",

        Approved: asset?.approved ? "Yes" : "No",

        "Approved By": asset?.approvedByData?.name || "N/A",

        Company: asset?.company || "N/A",

        Quantity: asset?.quantity || 0,

        Hub: asset?.hubData?.name || "N/A",

        "Unit Cost": asset?.assetType?.unitCost || 0,
        Amount: getAmount(asset),

        Description: asset?.description || "",
      }));

      const worksheet = XLSX.utils.json_to_sheet(transformedData);

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "Assets");

      XLSX.writeFile(
        workbook,
        `Assets_${new Date().toISOString().split("T")[0]}.xlsx`,
      );

      Swal.close();
    } catch (error) {
      console.error(
        "Error exporting assets:",
        error.response?.data || error.message,
      );

      Swal.fire("Error!", "Assets could not be exported.", "error");
    }
  };

  // ============================================================
  // UI
  // ============================================================

  return (
    <>
      <Layouts />

      <Status_modal row={selectVal} openModal={openModal} />

      <Add_data_modal
        select_data={update_modal_data}
        open_update_data_modal={open_update_modal}
        onUpdateAsset={handleUpdateAsset}
      />

      <AssetDetailModal
        show={showAssetDetailModal}
        onHide={() => setShowAssetDetailModal(false)}
        asset={selectedAsset}
      />

      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div
              className="card"
              style={{
                borderTop: "2px solid #4723d9",
              }}
            >
              {/* =====================================================
                  HEADER + SUMMARY
              ====================================================== */}

              <div
                className="card-header bg-white d-flex align-items-center justify-content-between flex-wrap"
                style={{
                  padding: "10px 16px",
                  borderBottom: "1px solid #dee2e6",
                  gap: "10px",
                }}
              >
                {/* LEFT SIDE - TITLE + SUMMARY */}

                <div
                  className="d-flex align-items-center flex-wrap"
                  style={{
                    gap: "6px",
                  }}
                >
                  {/* TITLE */}

                  <h5
                    className="mb-0 me-2"
                    style={{
                      fontWeight: "400",
                      color: "#343a40",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <b> Assets Details </b>
                  </h5>

                  {/* TOTAL ASSETS */}

                  <div
                    className="d-flex align-items-center px-3 py-2"
                    style={{
                      background: "#f5f3ff",
                      border: "1px solid #d8d0ff",
                      borderRadius: "8px",
                      minWidth: "120px",
                      height: "40px",
                    }}
                  >
                    <span
                      className="me-2"
                      style={{
                        width: "26px",
                        height: "26px",
                        borderRadius: "50%",
                        background: "#e8e3ff",
                        color: "#4723d9",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      A
                    </span>

                    <span
                      style={{
                        color: "#555",
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Asset
                    </span>

                    <strong
                      className="ms-2"
                      style={{
                        color: "#4723d9",
                        fontSize: "14px",
                      }}
                    >
                      {summary.count || 0}
                    </strong>
                  </div>

                  {/* TOTAL AMOUNT */}

                  <div
                    className="d-flex align-items-center px-3 py-2"
                    style={{
                      background: "#eef7ff",
                      border: "1px solid #cfe5f8",
                      borderRadius: "8px",
                      minWidth: "135px",
                      height: "40px",
                    }}
                  >
                    <span
                      className="me-2"
                      style={{
                        width: "26px",
                        height: "26px",
                        borderRadius: "50%",
                        background: "#dceeff",
                        color: "#0878d1",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      ₹
                    </span>

                    <span
                      style={{
                        color: "#555",
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Amount
                    </span>

                    <strong
                      className="ms-2"
                      style={{
                        color: "#0878d1",
                        fontSize: "14px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      ₹{Number(summary.amount || 0).toLocaleString("en-IN")}
                    </strong>
                  </div>

                  {/* TOTAL QUANTITY */}

                  <div
                    className="d-flex align-items-center px-3 py-2"
                    style={{
                      background: "#effaf2",
                      border: "1px solid #d4ebda",
                      borderRadius: "8px",
                      minWidth: "125px",
                      height: "40px",
                    }}
                  >
                    <span
                      className="me-2"
                      style={{
                        width: "26px",
                        height: "26px",
                        borderRadius: "50%",
                        background: "#dff3e4",
                        color: "#218838",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      Q
                    </span>

                    <span
                      style={{
                        color: "#555",
                        fontSize: "13px",
                      }}
                    >
                      Quantity
                    </span>

                    <strong
                      className="ms-2"
                      style={{
                        color: "#218838",
                        fontSize: "14px",
                      }}
                    >
                      {summary.quantity || 0}
                    </strong>
                  </div>
                </div>

                {/* RIGHT SIDE - ACTIONS */}

                <div className="d-flex align-items-center gap-2">
                  {/* EXPORT */}

                  <button
                    type="button"
                    className="btn btn-success btn-sm text-white px-3"
                    onClick={exportToExcel}
                    style={{
                      borderRadius: "5px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Export To Excel
                  </button>

                  {/* ADD ASSET */}

                  <Link to="/create_asset" className="text-decoration-none">
                    <button
                      type="button"
                      className="btn btn-info btn-sm text-white px-3"
                      style={{
                        borderRadius: "5px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Add Asset
                    </button>
                  </Link>
                </div>
              </div>

              {/* =====================================================
                  TABLE
              ====================================================== */}

              <div className="card-body pt-2">
                {loading ? (
                  <div className="text-center py-4">Loading assets...</div>
                ) : (
                  <DataTable_Component
                    apidata={apistate}
                    columns={columns}
                    search={search}
                    setSearch={setSearch}
                    filters={filters}
                    onApplyFilters={handleApplyFilters}
                    onClearFilters={handleClearFilters}
                    currentPage={currentPage}
                    totalRows={totalAssets}
                    rowsPerPage={rowsPerPage}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handleRowsPerPageChange}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
